var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrinkCup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 12.8467L5.10667 12.7867C4.6 12.74 4.16667 12.4 4 11.9133C3.64605 10.6035 3.64605 9.22318 4 7.91333C5.54667 7.6 6.66667 6.24667 6.66667 4.66667C6.66667 3.33333 5.33333 0 5.33333 0H1.33333C1.33333 0 6.94856e-08 3.33333 6.94856e-08 4.66667C-0.000156767 5.4351 0.265189 6.17999 0.751129 6.77527C1.23707 7.37054 1.91376 7.77965 2.66667 7.93333C3.02 9.24 3.02 10.6267 2.66667 11.9333C2.50667 12.4133 2.08 12.7533 1.58 12.8067L1 12.8667C1 12.8667 0.666667 12.8533 0.666667 13.3333H6C6 12.8533 5.66667 12.8467 5.66667 12.8467ZM1.62667 3.33333L2.29333 1.33333H4.37333L5.04 3.33333H1.62667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkCup);
export default __webpack_public_path__ + "static/media/drinkCup.65b7138c0445e5bd2750f0989edc8e3e.svg";
export { ForwardRef as ReactComponent };